type ApiErrorBody = {
  error?: {
    message?: string
  }
}

export const hubSpotDealLinkErrorMessage = async (
  res: Response,
  fallback: string
): Promise<string> => {
  if (typeof res?.json !== 'function') {
    return fallback
  }

  const body: ApiErrorBody | undefined = await res.json().catch(() => undefined)

  return body?.error?.message || fallback
}
